import {
  JavaScript,
  TypeScript,
  Html,
  Css,
  Sass,
  ReactIcon,
  Node,
  Npm,
  Mysql,
  Mongodb,
  Java,
  Tailwind,
  GitHub,
  Figma,
  Adobe,
  Windows,
  Macos,
  Xcode,
  Swift,
  JQuery,
  // Jest,
  Docker,
  Vscode,
  Postman,
  Express,
  Angular,
  Php,
  // Liquid,
  Vtex,
  Shopify,
  Wake,
  Graphql
} from '../../assets/Icons/Icons';


const skills = [
  { label: 'JavaScript', icon: JavaScript, bg: '#f7df1e' },
  { label: 'TypeScript', icon: TypeScript, bg: '#3178c6' },
  { label: 'HTML', icon: Html, bg: '#e34f26' },
  { label: 'CSS', icon: Css, bg: '#264de4' },
  { label: 'SASS', icon: Sass, bg: '#cd6799' },
  { label: 'React', icon: ReactIcon, bg: '#61dafb' },
  { label: 'Node.js', icon: Node, bg: '#339933' },
  { label: 'NPM', icon: Npm, bg: '#cb3837' },
  { label: 'MySQL', icon: Mysql, bg: '#00758f' },
  { label: 'MongoDB', icon: Mongodb, bg: '#47a248' },
  { label: 'Java', icon: Java, bg: '#007396' },
  { label: 'Git', icon: GitHub, bg: '#f05032' },
  { label: 'Tailwind', icon: Tailwind, bg: '#06b6d4' },
  { label: 'Figma', icon: Figma, bg: '#f24e1e' },
  { label: 'Adobe Photoshop', icon: Adobe, bg: '#31a8ff' },
  { label: 'Windows', icon: Windows, bg: '#00adef' },
  { label: 'MacOS', icon: Macos, bg: '#fff' },
  { label: 'Xcode', icon: Xcode, bg: '#147efb' },
  { label: 'SwiftUI', icon: Swift, bg: '#f05138' },
  { label: 'JQuery', icon: JQuery, bg: '#0769ad' },
  // { label: 'Jest.js', icon: Jest, bg: '#99425b' },
  { label: 'Docker', icon: Docker, bg: '#2496ed' },
  { label: 'VS Code', icon: Vscode, bg: '#007acc' },
  { label: 'PostMan', icon: Postman, bg: '#ff6c37' },
  { label: 'Express.js', icon: Express, bg: '#fff' },
  { label: 'Angular', icon: Angular, bg: '#dd0031' },
  { label: 'PHP', icon: Php, bg: '#777bb4' },
  // { label: 'Liquid', icon: Liquid, bg: '#fff' },
  { label: 'VTEX', icon: Vtex, bg: '#E31C58' },
  { label: 'Shopify', icon: Shopify, bg: '#96bf48' },
  { label: 'Wake', icon: Wake, bg: '#fff' },
  { label: 'Graphql', icon: Graphql, bg: '#e535ab' },

];
export default skills;
